import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Container, ContainerProps, IconButton, Typography, styled } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const WithResponsiveText = styled(Container)(({ theme }) => {
	const isMobile = theme.breakpoints.down("sm");
	return `
		${isMobile} {
			& h1 {
				font-size: 1.25rem;
			}
			& h2 {
				font-size: 1.1rem;
			}
		}
	`;
});

function ContentWrapper(props: ContainerProps) {
	const navigate = useNavigate();
	const { t } = useTranslation();
	return (
		<Container maxWidth={props.maxWidth ?? "md"}>
			<IconButton
				onClick={() => {
					navigate(-1);
				}}
			>
				<ArrowBackIcon color="primary" />
				<Typography variant="h6" color="primary">
					{t("back")}
				</Typography>
			</IconButton>
			<WithResponsiveText
				maxWidth={props.maxWidth ?? "md"}
				sx={{ p: { sm: 4, xs: 2 }, bgcolor: "white", ...props.sx }}
			>
				{props.children}
			</WithResponsiveText>
			<IconButton
				onClick={() => {
					navigate(-1);
				}}
			>
				<ArrowBackIcon color="primary" />
				<Typography variant="h6" color="primary">
					{t("back")}
				</Typography>
			</IconButton>
		</Container>
	);
}

export default ContentWrapper;
